<script setup></script>

<template>
  <div class="fixed inset-x-0 top-0 z-50 h-1 bg-red-600" title="Dev mode"></div>
</template>
